import { gql } from '@apollo/client';

export default gql`
  mutation enterRoomInPositioningSession($sessionId: UUID!, $bracelets: [String!]!, $roomId: Long!) {
    enterRoomInPositioningSession(sessionId: $sessionId, bracelets: $bracelets, roomId: $roomId)
  }
`;
